'use client';

import { useEffect } from 'react';

import { logNextErrorBoundary } from './_components/errorBoundaryReporting';

type ErrorBoundaryProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorBoundary({ error, reset }: ErrorBoundaryProps) {
  useEffect(() => {
    logNextErrorBoundary(error, 'app');
  }, [error]);

  return (
    <main style={{ margin: '0 auto', maxWidth: 720, padding: '64px 24px', fontFamily: 'inherit' }}>
      <h1>Something went wrong</h1>
      <p>We could not load this page. Try again, or return to HotPads and start a new search.</p>
      {error.digest && <p>Reference: {error.digest}</p>}
      <button type="button" onClick={reset}>
        Try again
      </button>
    </main>
  );
}
